import { Component, Input } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'regenerate-key-confirm-component',
  templateUrl: './regenerate-key-confirm.component.html',
  styleUrls: ['./regenerate-key-confirm.component.scss'],
})
export class RegenerateKeyConfirmComponent {
  @Input() public data: any;

  constructor(
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = { type: 'access' };
  }

  confirm() {
    this.sharedService.sendMessage('REGENERATE_KEY_CONFIRM', this.data.type);
    this.modalsService.hideModal();
  }

  cancel() {
    this.modalsService.hideModal();
  }
}
